import axios from 'axios';
import { storage } from '../../../utils/storage'

const qs = require('qs');

export const signup = (data) => {
  return (dispatch) => {
    axios
      .post('/api_v_1/user/save', data)
      .then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: {
            general:
              'Successfully Registered,Please check your registered email for OTP!'
          }
        });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: data.response.data.message }
        });
        dispatch({ type: 'USER_SIGNUP', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: error.response.data.message }
          });
        } catch {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const searchItems = (data) => {
  return (dispatch) => {
    dispatch({ type: 'API_PROGRESS', payload: true });
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/searchVendorProduct?searchParam=${data.searchParam}&latitude=${data.latitude}&longitude=${data.longitude}`)
        .then((data) => {
          dispatch({ type: 'GLOBAL_SEARCH', payload: data.data });
          dispatch({ type: 'API_PROGRESS', payload: false });
          resolve(data?.data)
        })
        .catch((error) => {
          reject(false);
          dispatch({ type: 'API_PROGRESS', payload: false });
        });
    });
  };
}

export const getOfferMessage = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/offersMessageList`)
        .then((data) => {
          dispatch({ type: 'OFFER_MESSAGE', payload: data.data });
        })
        .catch((error) => {
          reject(false);
          dispatch({ type: 'API_PROGRESS', payload: false });
        });
    });
  };
}

export const verifyOptCode = (data) => {
  return (dispatch) => {
    dispatch({ type: 'COMMON_LOADING' });
    axios
      .post('/api_v_1/user/verify-otp', data)
      .then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: {
            general: 'Your account is Verified. You may actually login'
          }
        });
        dispatch({ type: 'USER_LOGIN' });
        dispatch({ type: 'COMMON_UNLOADING' });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: error.response.data.message }
          });
        } catch {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const resendOptCode = (data) => {
  return (dispatch) => {
    dispatch({ type: 'COMMON_LOADING' });
    axios
      .post('/api_v_1/user/resend-otp', data)
      .then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: {
            general:
              'Please verify your email inbox, and return back to enter the code you receive'
          }
        });
        dispatch({ type: 'USER_LOGIN' });
        dispatch({ type: 'COMMON_UNLOADING' });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: error.response.data.message }
          });
        } catch {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const login = (data) => {
  return (dispatch) => {
    dispatch({ type: 'COMMON_LOADING' });
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/login', data)
        .then((data) => {
          localStorage.setItem('uid', data.data.uid);
          localStorage.setItem('email', data.data.emailId);
          localStorage.setItem('name', data.data.emailId);
          localStorage.setItem(
            'vendorSuperCategoryId',
            JSON.stringify(['sdsd-sadsad-sdadas'])
          );
          localStorage.setItem('userLoginType', 'admin');
          setAuthorizationHandler(data.data.token);

          dispatch({ type: 'USER_LOGIN' });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Login successful' }
          });
          dispatch({ type: 'COMMON_UNLOADING' });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data.message }
            });
          } catch {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          }
          resolve(false);
        });
    })
  };
};

export const loginUser = (data) => {
  return (dispatch) => {
    dispatch({ type: 'COMMON_LOADING' });
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/user/login', data)
        .then((data) => {
          localStorage.setItem('uid', data.data.data.id);
          localStorage.setItem('email', data.data.data.emailId);
          localStorage.setItem('name', data.data.data.firstName);
          localStorage.setItem('userLoginType', 'user');
          setAuthorizationHandler(data.data.token);

          dispatch({ type: 'USER_LOGIN' });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Login successful' }
          });
          dispatch({ type: 'COMMON_UNLOADING' });
          resolve(true);
          // setTimeout(() => {
          //   window.location.reload(false);
          // }, 3000);
        })
        .catch((error) => {
          reject(false);
          try {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data.message }
            });
          } catch {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          }
        });
    });
  };
};

export const loginUserOTPReceived = (data) => {
  delete data['emailId'];
  delete data['password'];
  var country_code = data.country_code
  data.country_code = country_code.replace('+', '')
  var phone_number = data.phone_number
  data.phone_number = phone_number.replace('-', '')
  return (dispatch) => {
    dispatch({ type: 'COMMON_LOADING' });
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/user/verify/otp', data)
        .then((data) => {
          localStorage.setItem('uid', data.data.data.id);
          localStorage.setItem('email', data.data.data.emailId);
          localStorage.setItem('name', data.data.data.firstName);
          localStorage.setItem('userLoginType', 'user');
          setAuthorizationHandler(data.data.token);

          dispatch({ type: 'USER_LOGIN' });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Login successful' }
          });
          dispatch({ type: 'COMMON_UNLOADING' });
          resolve(true);
          // setTimeout(() => {
          //   window.location.reload(false);
          // }, 3000);
        })
        .catch((error) => {
          reject(error);
          try {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data.message }
            });
          } catch {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          }
        });
    });
  };
};


export const loginUserOTP = (data) => {
  var country_code = data.country_code
  country_code = country_code.replace('+', '')
  var phone_number = data.phone_number
  phone_number = phone_number.replace('-', '')
  return (dispatch) => {
    dispatch({ type: 'COMMON_LOADING' });
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/user/phone/login', { country_code, phone_number })
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'OTP Sent Successfully' }
          });
          dispatch({ type: 'COMMON_UNLOADING' });
          resolve(true);
          // setTimeout(() => {
          //   window.location.reload(false);
          // }, 3000);
        })
        .catch((error) => {
          reject(false);
          try {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data.message }
            });
          } catch {
            dispatch({ type: 'COMMON_UNLOADING' });
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          }
        });
    });
  };
};

export const forgetPassword = (data) => {
  return (dispatch) => {
    dispatch({ type: 'COMMON_LOADING' });
    axios
      .post('/api_v_1/user/forgetpassword', data)
      .then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Please check your inbox to reset your pasword' }
        });
        dispatch({ type: 'FORGET_PASSWORD' });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: error.response.data.message }
          });
        } catch {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const updateUser = (data) => {
  return (dispatch) => {
    axios
      .put('/api_v_1/user/update', data)
      .then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Successfully Updated' }
        });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: data.response.data.message }
        });
        dispatch({ type: 'USER_UPDATE', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: error.response.data.message }
          });
        } catch {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const updatePassword = (data) => {
  return (dispatch) => {
    axios
      .post('/api_v_1/user/changepassword', data)
      .then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Successfully Updated' }
        });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: data.response.data.message }
        });
        dispatch({ type: 'UPDATE_PASSWORD', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: error.response.data.message }
          });
        } catch {
          dispatch({ type: 'COMMON_UNLOADING' });
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllSuperCategory = () => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    return new Promise((resolve, reject) => {
      axios
        .get('/api_v_1/supercategories')
        .then((data) => {
          dispatch({ type: 'GET_SUPERCATEGORY_HOME', payload: data.data });
          dispatch({ type: 'USER_UNLOADING' });
          resolve(data?.data)
        })
        .catch((error) => {
          reject(false);
          dispatch({
            type: 'GET_SUPERCATEGORY_HOME_ERROR',
            payload: error?.response?.data,
          });
        });
    });
  };
};

export const getAllCategory = (superCategory) => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    axios
      .get(
        `/api_v_1/categoryAndSubCategory?superCategoryId=${superCategory}`
      )
      .then((data) => {
        dispatch({ type: 'GET_CATEGORY_HOME', payload: data.data });
        dispatch({ type: 'USER_UNLOADING' });
      })
      .catch((error) => {
        dispatch({
          type: 'GET_CATEGORY_HOME_ERROR',
          payload: 'Please, try again'
        });
        dispatch({ type: 'USER_UNLOADING' });
      });
  };
};

export const getAllRestaurantType = (superCategory) => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    axios
      .get(
        `/api_v_1/restaurantType?superCategoryId=${superCategory}`
      )
      .then((data) => {
        dispatch({ type: 'GET_ALL_RESTAURANT_TYPE', payload: data.data });
        dispatch({ type: 'USER_UNLOADING' });
      })
      .catch((error) => {
        dispatch({
          type: 'GET_ALL_RESTAURANT_TYPE_ERROR',
          payload: 'Please, try again'
        });
        dispatch({ type: 'USER_UNLOADING' });
      });
  };
};

export const getAllSubCategory = () => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    axios
      .get('/api_v_1/supercategories')
      .then((data) => {
        dispatch({ type: 'GET_CATEGORY_HOME', payload: data.data });
        dispatch({ type: 'USER_UNLOADING' });
      })
      .catch((error) => {
        dispatch({
          type: 'GET_CATEGORY_HOME_ERROR',
          payload: error.response.data
        });
        dispatch({ type: 'USER_UNLOADING' });
      });
  };
};
export const getUserDetails = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/user/profile`)
        .then((data) => {
          dispatch({ type: 'GET_USER_DETAILS', payload: data.data });
          resolve(true);
        })
        .catch((error) => {
          reject(false);
          try {
            dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          } catch {
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          }
        });
    });
  };
};
export const addToWallet = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/user/addMoneyToWallet', payload)
        .then((data) => {
          dispatch({ type: 'SUCCESS_MESSAGE', payload: { general: data.data.message } });
          resolve(true)
        })
        .catch((error) => {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          reject(true)
        });
    });
  };
}
export const WithgetAllVendors = (
  superCategoryId,
  superCategory,
  latitude,
  longitude
) => {
  return (dispatch) => {
    dispatch({ type: 'VENDOR_LOADING' });
    var data = {
      superCategoryId: superCategoryId,
      latitude: latitude,
      longitude: longitude
    };
    axios
      .post('/api_v_1/vendorListing?', data)
      .then((result) => {
        if (result.status === 200) {
          dispatch({
            type: 'GET_VENDORS2',
            payload: { data: result.data.data, type: superCategory }
          });
        } else if (result.status === 500) {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { error: 'Network Error' }
          });
        }
      })
      .catch((error) => {
        console.log('the error', error);
      });
    dispatch({ type: 'VENDOR_UNLOADING' });
  };
};

export const getAllVendors = (city, latitude, longitude, superCategory) => {
  return (dispatch) => {
    dispatch({ type: 'VENDOR_LOADING' });
    if (true) {
      if (true) {
        dispatch({
          type: 'GET_VENDORS',
          payload: { data: [], type: superCategory }
        });
        localStorage.removeItem('preCity');
      }
    }
    axios
      .get(
        `/api_v_1/vendorListing/${superCategory}/?latitude=${latitude}&longitude=${longitude}&`
      )
      .then((data) => {
        return data.data.data;
      })
      .then((vendors) => {
        var user = { latitude: latitude, longitude: longitude };
        var data = qs.stringify({
          shop: JSON.stringify(vendors),
          user: JSON.stringify(user)
        });
        axios
          .post('https://nearest-vendor.herokuapp.com', data.data, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then((result) => {
            if (result.status === 200) {
              dispatch({
                type: 'GET_VENDORS',
                payload: { data: result.data.data, type: superCategory }
              });
            } else if (result.status === 500) {
              dispatch({
                type: 'ERROR_MESSAGE',
                payload: { error: 'Network Error' }
              });
            }
          })

          .catch((error) => {
            dispatch({ type: 'VENDOR_UNLOADING' });
            try {
              dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
            } catch (error) {
              dispatch({
                type: 'ERROR_MESSAGE',
                payload: { error: 'Network Error' }
              });
            }
          });
        dispatch({ type: 'VENDOR_UNLOADING' });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch (error) {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { error: 'Network Error' }
          });
        }

        dispatch({ type: 'VENDOR_UNLOADING' });
      });
  };
};

export const getAllProducts = (category, uid) => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    dispatch({
      type: 'GET_CATEGORY_PRODUCTS',
      payload: { data: [], type: category }
    });
    axios
      .get(`/api_v_1/get/category/all/products/${uid}/${category}`)
      .then((data) => {
        dispatch({
          type: 'GET_CATEGORY_PRODUCTS',
          payload: { data: data.data, type: category }
        });
        dispatch({ type: 'USER_UNLOADING' });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch (error) {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'Network Error' });
        }
        dispatch({ type: 'USER_UNLOADING' });
      });
  };
};

export const getSubCategoryProducts = (category, uid, subCategory) => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    axios
      .get(`/api_v_1/get/product/${uid}/${category}/${subCategory}`)
      .then((data) => {
        dispatch({ type: 'GET_SUBCATEGORY_PRODUCTS', payload: data });
        dispatch({ type: 'USER_UNLOADING' });
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: error.response.data
        });
        dispatch({ type: 'USER_UNLOADING' });
      });
  };
};

export const getSubCategory = (category, uid) => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    axios
      .get(`/api_v_1/get/subcategory/${uid}/${category}`)
      .then((data) => {
        dispatch({
          type: 'GET_SUBCATEGORIES',
          payload: { data: data.data, type: category }
        });
        dispatch({ type: 'USER_UNLOADING' });
      })
      .catch((error) => {
        dispatch({ type: 'GET_SUBCATEGORIES_ERROR', payload: error });
        dispatch({ type: 'USER_UNLOADING' });
      });
  };
};

// export const addToCart = (uid, fproduct) => {
//   const product = { ...fproduct, quantity: 1 };
//   return (dispatch) => {
//     dispatch({type:'ALERT_LOAD'})
//     axios
//       .post("/user/add/to/cart", {
//         Id: uid,
//         product,
//       })
//       .then((data) => {
//         dispatch({type:"ADD_TO_CART",payload:data})
//         dispatch({type:'SUCCESS_MESSAGE',payload:data.data})
//       })
//       .catch((error) => {
//         try{dispatch({type:"ERROR_MESSAGE",payload:error.response.data});}catch(error){
//           dispatch({type:"ERROR_MESSAGE",payload:{error:'Net Error Occur'}});
//         }
//       });
//   };
// };

// export const removeFromCart = (uid, product) => {
//   return  (dispatch) => {
//     axios
//       .patch("/user/delete/from/cart", {
//         Id: uid,
//         product,
//       })
//       .then((data) => {
//         dispatch({type:'REMOVE_FROM_CART',payload:product})
//         dispatch({type:'SUCCESS_MESSAGE',payload:data.data})
//       })
//       .catch((error) => {
//         try{
//           dispatch({type:"ERROR_MESSAGE",payload:error.response.data});
//         }catch(error){
//           dispatch({type:"ERROR_MESSAGE",payload:'Network Error'});

//         }

//       });
//   };
// };

// export const getCart = (uid) => {
//   return (dispatch) => {
//     axios
//       .get(`/get/user/cart/${uid}`)
//       .then((data) => {
//         dispatch({ type: "GET_CART", payload:data });
//       })
//       .catch((error) => {
//         try{
//           dispatch({ type: "ERROR_MESSAGE", payload:error.response.data});
//         }catch(error){
//           dispatch({type:"ERROR_MESSAGE",payload:{error:'Network Error'}})
//         }

//       });
//   };
// };

// export const changeQuantity = (uid, product,prevProduct) => {
//   return async (dispatch) => {
//     axios
//       .patch("/update/user/cart", {
//         Id: uid,
//         prev:prevProduct,
//         new:product,
//       })
//       .then((data) => {
//         axios
//           .get(`/get/user/cart/${uid}`)
//           .then((data) => {
//             dispatch({ type: "GET_CART", payload: data });
//             return data
//           })
//           .catch((error) => {
//             dispatch({ type: "ERROR_MESSAGE", payload:error.response.data });
//           });
//         // dispatch({type:"REMOVE_FROM_CART",payload:data})
//       })
//       .catch((error) => {
//         dispatch({type:"ERROR_MESSAGE",payload:error.response.data});

//       });
//   };
// };

export const getPromocode = () => {
  return (dispatch) => {
    axios
      .get('/api_v_1/get/all/promocode')
      .then((data) => {
        dispatch({ type: 'GET_PROMOCODE', payload: data });
      })
      .catch((error) => {
        dispatch({ type: 'GET_PROMOCODE_ERROR', payload: error });
      });
  };
};

export const calculateTotal = (address) => {
  return (dispatch) => {
    axios
      .post('/api_v_1/pickup/distanceAndPrice', address)
      .then((data) => {
        dispatch({ type: 'CALCULATE_DISTANCE', payload: data });
      })
      .catch((error) => {
        dispatch({ type: 'GET_PROMOCODE_ERROR', payload: error });
      });
  };
};

export const getZipcode = () => {
  return (dispatch) => {
    axios
      .get('/get/all/zipcode')
      .then((data) => {
        dispatch({ type: 'GET_ZIPCODE', payload: data.data.zipcode });
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const pushEvent = (data) => {
  return (dispatch) => {
    axios
      .post('/api_v_1/events/pushEvent', data)
      .then((data) => {
        dispatch({ type: 'EVENT_SAVED', payload: data });
      })
      .catch((error) => {
        // dispatch({ type: 'GET_PROMOCODE_ERROR', payload: error });
      });
  };
}

export const getMyOrders = () => {
  return (dispatch) => {
    dispatch({ type: 'USER_LOADING' });
    axios
      .get('/api_v_1/user/orders' + localStorage.getItem('uid'))
      .then((data) => {
        dispatch({ type: 'GET_MY_ORDERS', payload: data });
        dispatch({ type: 'USER_UNLOADING' });
      })
      .catch((error) => {
        dispatch({ type: 'GET_MY_ORDERS_ERROR', payload: error.response.data });
        dispatch({ type: 'USER_UNLOADING' });
      });
  };
};

export const sendMail = (details) => {
  return (dispatch) => {
    dispatch({ type: 'EMAIL_LOADING' });
    axios
      .post('https://mail-infinite.herokuapp.com/details', {
        emailfrom: details.email,
        emailto: 'harshdeepbhatia6841@gmail.com',
        text: `Phone Number : ${details.phone} \n ${details.address ? `Address : ${details.address}` : ''
          }`
      })
      .then((data) => {
        dispatch({ type: 'EMAIL_SUCCESS', payload: true });
        dispatch({ type: 'EMAIL_UNLOADING' });
        setTimeout(() => {
          dispatch({ type: 'EMAIL_SUCCESS', payload: false });
        }, 2500);
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to contact please try again' }
        });
        dispatch({ type: 'EMAIL_UNLOADING' });
      });
  };
};

export const placeOrder = (order) => {
  return (dispatch) => {
    axios
      .post('/api_v_1/confirm/order', order)
      .then((data) => {
        axios.post('/confirm/user/order', order).then((order) => {
          dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
          dispatch({ type: 'GET_CART', payload: { data: [] } });
          localStorage.removeItem('my_carts');
          // localStorage.clear();
          window.location.href = '/myOrders';
        });
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        // dispatch({type:CHECKOUT_ERROR,payload:error.response.data});
      });
  };
};


export const getVendorWithSuperCategory = (superCategory) => {
  return (dispatch) => {
    dispatch({ type: 'VENDORS_LOADING', payload: true });
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/vendorListing', superCategory)
        .then(async (data) => {
          await dispatch({
            type: 'SET_VENDOR_BY_SUPER_CATEGORY',
            payload: data.data
          });
          dispatch({ type: 'VENDORS_LOADING', payload: false });
          resolve(data?.data);
        })
        .catch((err) => {
          dispatch({ type: 'VENDORS_LOADING', payload: false });
          reject(false);
        });
    });
  };
};

export const getAllCategoriesAndSubCategories = (superCategoryId, vendorId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/categoryAndSubCategory?superCategoryId=${superCategoryId}&vendorId=${vendorId}`)
        .then((resp) => {
          resolve(resp.data);
          // dispatch({ type: 'SET_CATEGORY_AND_SUB_CATEGORY', payload: resp.data});
        })
        .catch((err) => { });
    });
  };
};
export const getVendorProducts = (vendorId) => {
  return (dispatch) => {
    dispatch({ type: 'PRODUCT_LOADING', payload: true });
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/vendorProductListing?vendorId=${vendorId}`)
        .then((resp) => {
          // dispatch({ type: 'SET_VENDOR_PRODUCT', payload: resp.data});
          dispatch({ type: 'PRODUCT_LOADING', payload: false });
          resolve(resp.data);
        })
        .catch((err) => { });
    });
  };
};
export const getVendorOffers = (vendorId) => {
  return (dispatch) => {
    dispatch({ type: 'PRODUCT_LOADING', payload: true });
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/vendorProductListing?vendorId=${vendorId}&isOffer=${true}`)
        .then((resp) => {
          // dispatch({ type: 'SET_VENDOR_PRODUCT', payload: resp.data});
          dispatch({ type: 'PRODUCT_LOADING', payload: false });
          resolve(resp.data);
        })
        .catch((err) => { });
    });
  };
};
export const getVendorById = (superCategory, vendorId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/vendorDetails?vendorId=${vendorId}&latitude=${superCategory.latitude}&longitude=${superCategory.longitude}`)
        .then(async (data) => {
          await dispatch({
            type: 'SET_VENDOR_BY_ID',
            payload: data.data
          });
          resolve(data?.data);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};
export const getVendorMenus = (vendorId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.get(`/api_v_1/vendorMenuListing?vendorId=${vendorId}`).then(resp => {
        resolve(resp.data)
      }).catch(err => {

      })
    });
  };
};

export const toggleSignUp = (isOpen) => {
  return (dispatch) => {
    dispatch({ type: 'TOGGLE_SIGNUP', payload: isOpen });
  };
};

export const getCartItems = () => {
  return (dispatch) => {
    axios
      .get('/api_v_1/cartList')
      .then((data) => {
        dispatch({ type: 'GET_CART', payload: data.data });
      })
      .catch((err) => { });
  };
};

export const verifyCouponCode = (data) => {
  return (dispatch) => {
    axios
      .post('/api_v_1/validate-discount', data)
      .then((data) => {
        dispatch({ type: 'VERIFY_COUPON_CODE', payload: data.data });
        dispatch({ type: 'SUCCESS_MESSAGE', payload: { general: 'Discount Applied' } });

      })
      .catch((err) => { });
  };
};

export const getCartItemsLocal = () => {
  return (dispatch) => {
    dispatch({ type: 'GET_CART_LOCAL', payload: storage.getItem('my_carts') ? JSON.parse(storage.getItem('my_carts')) : [] });
  };
}

export const addToCart = (product) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/addToCart', product)
        .then((data) => {
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const addToCartLocal = (data, vendor) => {
  data.vendor = vendor
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      var cart = storage.getItem('my_carts')
      if (cart && cart.length > 0 && cart !== 'null') {
        var cartObj = JSON.parse(cart)
        if (cartObj) {
          cartObj.push(data);
          storage.setItem('my_carts', JSON.stringify(cartObj))
        }else{
          storage.setItem('my_carts', JSON.stringify([data]))
        }
      } else {
        storage.setItem('my_carts', JSON.stringify([data]))
      }
      dispatch({ type: 'UPDATE_LOCAL_CART', payload: data });
      resolve(true);
    });
  };
};

export const updateCart = (product) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/api_v_1/updateCart', product)
        .then((data) => {
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const updateCartCoupon = (cart) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/api_v_1/updateCartCoupon', cart)
        .then((data) => {
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const updateCartLocal = (product, key) => {
  return (dispatch) => {
    const cart = storage.getItem('my_carts')
    if (cart) {
      var cartObj = JSON.parse(cart)
      const mapObj = cartObj.map((c) => {
        if (c[key] === product[key]) {
          c.quantity = product.quantity
        }
        return c;
      })
      storage.setItem('my_carts', JSON.stringify(mapObj))
      dispatch({
        type: 'GET_CART_LOCAL',
        payload: mapObj
      })
    }
  }
}

export const updateCartObjLocal = (coupon, key) => {
  return (dispatch) => {
    const cart = storage.getItem('my_carts')
    if (cart) {
      var cartObj = JSON.parse(cart)
      const mapObj = cartObj.map((c) => {
        c.coupon = coupon
        return c;
      })
      storage.setItem('my_carts', JSON.stringify(mapObj))
      dispatch({
        type: 'GET_CART_LOCAL',
        payload: mapObj
      })
    }
  }
}

export const deleteCartItemLocal = (product, key) => {
  return (dispatch) => {
    const cart = storage.getItem('my_carts')
    if (cart) {
      var cartObj = JSON.parse(cart)
      var found = false
      if (cartObj && product) {
        const mapObj = cartObj.filter((c) => {
          if (c[key] === product[key] && !found) {
            found = true;
            return false
          }
          return true
        })
        storage.setItem('my_carts', JSON.stringify(mapObj))
        dispatch({
          type: 'GET_CART_LOCAL',
          payload: mapObj
        })
      }
    }
  }
}

export const deleteCartItem = (cartId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api_v_1/deleteCartItem/${cartId}`)
        .then((data) => {
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const emptyCart = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api_v_1/emptyCart`)
        .then((data) => {
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const placeNewOrder = (checkout) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/placeOrder', checkout)
        .then(async (data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Order Placed Successfully' }
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: 'Order Not yet placed Contact Support' }
          });
          reject(false);
        });
    });
  };
};

export const errorReport = (message) => {
  return (dispatch) => {
    dispatch({
      type: 'ERROR_MESSAGE',
      payload: { general: message }
    });
  }
}

export const successReport = (message) => {
  return (dispatch) => {
    dispatch({
      type: 'SUCCESS_MESSAGE',
      payload: { general: message }
    });
  }
}

export const verifyDeliveryLocation = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/verifyDeliveryToAddress', data)
        .then(async (resp) => {
          resolve(resp?.data);
        })
    });
  };
};

export const saveNewAddress = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api_v_1/user/save-address', data)
        .then(async (resp) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'New Address Saved Successfully' }
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: 'Please Contact Support' }
          });
          reject(false);
        });
    });
  };
};

export const getAllOrders = (pageNumber, count = 10, startTime = '', endTime = '') => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/user/orderHistory?page_number=${pageNumber}&per_page_limit=${count}&startTime=${startTime}&endTime=${endTime}`)
        .then((resp) => {
          dispatch({
            type: 'ORDER_LIST',
            payload: resp.data
          });
          resolve(true);
        })
        .catch((err) => { });
    });
  };
};

export const getAllOrdersForDownload = (pageNumber, count = 10, startTime = '', endTime = '') => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/user/orderHistory?page_number=${pageNumber}&per_page_limit=${count}&startTime=${startTime}&endTime=${endTime}`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => { });
    });
  };
};

export const getAllTransactions = (pageNumber, count = 10) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/user/transactionHistory?page_number=${pageNumber}&per_page_limit=${count}`)
        .then((resp) => {
          dispatch({
            type: 'TRANSACTION_LIST',
            payload: resp.data
          });
          resolve(true);
        })
        .catch((err) => { });
    });
  };
};

const setAuthorizationHandler = (token) => {
  const fireToken = `Bearer ${token}`;
  axios.defaults.headers.common['Authorization'] = fireToken;
  localStorage.setItem('token', fireToken);
};
